import { css } from '@emotion/react';
import { pxToRem } from './pxToRem';

const fontFamily = 'CircularXX, -apple-system, BlinkMacSystemFont, "Avenir Next", "Segoe UI", Roboto, sans-serif';
const fontWeight = {
  normal: 400,
  bold: 700,
};
const fontSize = {
  tiny: 10,
  xxxSmall: 8,
  xxSmall: 10,
  xSmall: 12,
  small: 14,
  medium: 16,
  large: 18,
  xLarge: 20,
  xxLarge: 24,
  xxxLarge: 32,
};
export const TYPOGRAPHY2 = {
  fontFamily,
  fontSize,
  fontWeight,
  xxxLargeBold: css`
    font-family: ${fontFamily};
    font-size: ${pxToRem(fontSize.xxxLarge)};
    font-weight: ${fontWeight.bold};
  `,
  xxxLarge: css`
    font-family: ${fontFamily};
    font-size: ${pxToRem(fontSize.xxxLarge)};
    font-weight: ${fontWeight.normal};
  `,
  xxLargeBold: css`
    font-family: ${fontFamily};
    font-size: ${pxToRem(fontSize.xxLarge)};
    font-weight: ${fontWeight.bold};
  `,
  xxLarge: css`
    font-family: ${fontFamily};
    font-size: ${pxToRem(fontSize.xxLarge)};
    font-weight: ${fontWeight.normal};
  `,
  xLargeBold: css`
    font-family: ${fontFamily};
    font-size: ${pxToRem(fontSize.xLarge)};
    font-weight: ${fontWeight.bold};
  `,
  xLarge: css`
    font-family: ${fontFamily};
    font-size: ${pxToRem(fontSize.xLarge)};
    font-weight: ${fontWeight.normal};
  `,

  largeBold: css`
    font-family: ${fontFamily};
    font-size: ${pxToRem(fontSize.large)};
    font-weight: ${fontWeight.bold};
  `,
  large: css`
    font-family: ${fontFamily};
    font-size: ${pxToRem(fontSize.large)};
    font-weight: ${fontWeight.normal};
  `,

  mediumBold: css`
    font-family: ${fontFamily};
    font-size: ${pxToRem(fontSize.medium)};
    font-weight: ${fontWeight.bold};
  `,
  medium: css`
    font-family: ${fontFamily};
    font-size: ${pxToRem(fontSize.medium)};
    font-weight: ${fontWeight.normal};
  `,

  smallBold: css`
    font-family: ${fontFamily};
    font-size: ${pxToRem(fontSize.small)};
    font-weight: ${fontWeight.bold};
  `,
  small: css`
    font-family: ${fontFamily};
    font-size: ${pxToRem(fontSize.small)};
    font-weight: ${fontWeight.normal};
  `,

  xSmallBold: css`
    font-family: ${fontFamily};
    font-size: ${pxToRem(fontSize.xSmall)};
    font-weight: ${fontWeight.bold};
  `,
  xSmall: css`
    font-family: ${fontFamily};
    font-size: ${pxToRem(fontSize.xSmall)};
    font-weight: ${fontWeight.normal};
  `,
  tinyBold: css`
    font-family: ${fontFamily};
    font-size: ${pxToRem(fontSize.tiny)};
    font-weight: ${fontWeight.bold};
  `,
  tiny: css`
    font-family: ${fontFamily};
    font-size: ${pxToRem(fontSize.tiny)};
    font-weight: ${fontWeight.normal};
  `,
  xxSmallBold: css`
    font-family: ${fontFamily};
    font-size: ${pxToRem(fontSize.tiny)};
    font-weight: ${fontWeight.bold};
  `,
  xxSmall: css`
    font-family: ${fontFamily};
    font-size: ${pxToRem(fontSize.tiny)};
    font-weight: ${fontWeight.normal};
  `,
  xxxSmallBold: css`
    font-family: ${fontFamily};
    font-size: ${pxToRem(fontSize.xxxSmall)};
    font-weight: ${fontWeight.bold};
  `,
  xxxSmall: css`
    font-family: ${fontFamily};
    font-size: ${pxToRem(fontSize.xxxSmall)};
    font-weight: ${fontWeight.normal};
  `,
};
